<div class="container">
    <div class="icon"><svg-icon [fontSize]="'120px'" [key]="'page-not-found'"></svg-icon></div>
    <div class="message">{{errorDescription}}</div>

    <nts-filled-button *ngIf="showRetry" [type]="1" [title]="'std_Retry' | NTSTranslate"
        [label]="'std_Retry' | NTSTranslate" (onClicked)="retry()">
    </nts-filled-button>
</div>
